/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSin } from '../../factoriesAny.js';
export var sinDependencies = {
  typedDependencies,
  createSin
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesSin.generated.js
// module id = 374
// module chunks = 2